import { render } from "./SidebarItem.vue?vue&type=template&id=7ff99176&scoped=true"
import script from "./SidebarItem.vue?vue&type=script&lang=js"
export * from "./SidebarItem.vue?vue&type=script&lang=js"

import "./SidebarItem.vue?vue&type=style&index=0&id=7ff99176&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7ff99176"

export default script